function findPlanById(plansSTM = [], planId, plans, period) {
  let id = plansSTM.find(id => id === planId)

  if (!id) {
    const correspondingId = Object.keys(plans).find(
      planKey => plans[planKey].oldPlanId === planId
    )
    id = correspondingId ? +correspondingId : undefined
  }

  return {
    id,
    period,
    hasChanged: id !== planId
  }
}

export default findPlanById
